/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateRepresentativeRequest,
  GetRepresentativeParams,
  ListRepresentativesParams,
  PaginatedRepresentativeDto,
  RenewRepresentativeContractRequest,
  RepresentativeDto,
  UpdateRepresentativeRequest,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getGetRepresentativeUrl = (id: string, params?: GetRepresentativeParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/sales/representatives/${id}?${stringifiedParams}`
    : `/api/v1/sales/representatives/${id}`;
};

/**
 * @summary Get representative
 */
export const getRepresentative = async (
  id: string,
  params?: GetRepresentativeParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<RepresentativeDto> => {
  return customFetch<RepresentativeDto>(getGetRepresentativeUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getUpdateRepresentativeUrl = (id: string) => {
  return `/api/v1/sales/representatives/${id}`;
};

/**
 * @summary Update representative
 */
export const updateRepresentative = async (
  id: string,
  updateRepresentativeRequest: UpdateRepresentativeRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateRepresentativeUrl(id), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateRepresentativeRequest),
  });
};

export const getDeleteRepresentativeUrl = (id: string) => {
  return `/api/v1/sales/representatives/${id}`;
};

/**
 * @summary Delete representative
 */
export const deleteRepresentative = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteRepresentativeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getListRepresentativesUrl = (params: ListRepresentativesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["countryCodes"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/sales/representatives?${stringifiedParams}`
    : `/api/v1/sales/representatives`;
};

/**
 * @summary List representatives
 */
export const listRepresentatives = async (
  params: ListRepresentativesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedRepresentativeDto> => {
  return customFetch<PaginatedRepresentativeDto>(getListRepresentativesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCreateRepresentativeUrl = () => {
  return `/api/v1/sales/representatives`;
};

/**
 * @summary Create representative
 */
export const createRepresentative = async (
  createRepresentativeRequest: CreateRepresentativeRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getCreateRepresentativeUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createRepresentativeRequest),
  });
};

export const getRestoreRepresentativeUrl = (id: string) => {
  return `/api/v1/sales/representatives/${id}/restore`;
};

/**
 * @summary Restore representative
 */
export const restoreRepresentative = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRestoreRepresentativeUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRenewRepresentativeContractUrl = (id: string) => {
  return `/api/v1/sales/representatives/${id}/contract/renew`;
};

/**
 * @summary Renew representative contract
 */
export const renewRepresentativeContract = async (
  id: string,
  renewRepresentativeContractRequest: RenewRepresentativeContractRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRenewRepresentativeContractUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(renewRepresentativeContractRequest),
  });
};
